$(document).ready(function(){
  addSubscriptionCart()
});

document.addEventListener('rebuy:smartcart.init', (event) => {
  console.log('rebuy:smartcart.init event', event.detail);
  addSubscriptionCart()
  //let cart = event && event.detail && event.detail.smartcart.cart.items ? event.detail.smartcart.cart.items : [];
  //showHideMembershipUpsell(cart);

});

//document.addEventListener('rebuy:cart.ready', (event) => { 
  //console.log('rebuy:cart.ready event', event.detail);

  /*
  //This the code that was used to hide Rebuy Cart and use Shopify Cart in international markets
  if (Shopify.routes.root != "/") {
      Rebuy.SmartCart.destroy()
      document.querySelector("[data-ajax-cart-trigger]").addEventListener("click", () => {
          window.location.href = `${Shopify.routes.root}cart`
      });
  };

  setTimeout(() => {
      if (Shopify.routes.root != "/") {
          Rebuy.SmartCart.destroy()
          document.querySelectorAll(".header-cart.action-area__link ").forEach(element => {
              element.addEventListener("click", () => {
                  window.location.href = `${Shopify.routes.root}cart`
              });
          })
      };
  }, 100)
  */

  //run in Smart Cart "Ready" callback
  //some random formatting thing
  /*
  const tieredBar = document.querySelector(".rebuy-cart__progress-bar-container")

  const cartBody = document.querySelector(".rebuy-cart__flyout-content")

  cartBody.prepend(tieredBar)
  tieredBar.style.width = "100%"
  */

//});

document.addEventListener('rebuy:cart.change', (event) => { 
  console.log('rebuy:cart.change event', event.detail);
  console.log('rebuy:cart.chanage event items', event.detail.cart.cart.items); 
  let cart = event && event.detail && event.detail.cart.cart.items ? event.detail.cart.cart.items : [];
  //showHideMembershipUpsell(cart);
});

function showHideMembershipUpsell(cart) {
  if (cart.length > 0) {
    const membershipInCart = cart.some(item => item.id == 40047148892235);
    if(membershipInCart) {
      console.log('hide');
      document.querySelectorAll('.membership-upsell').forEach(element => {
        element.style.display = "none";
      });
    }else {
      console.log('show');
      document.querySelectorAll('.membership-upsell').forEach(element => {
        element.style.display = "flex";
      });
    }
  }else{
    /*
    console.log('Cart is empty');
    //hide upsell widget with class name membership-upsell in cart drawer
    */
  }
}

function addSubscriptionCart() {
  var buttons = document.querySelectorAll(".membership-atc-action");
  buttons.forEach(function(button) {
      button.addEventListener("click", function() {
        fetch('/cart/add.js', {
          body: JSON.stringify({items: [
            {
              id: 40079979216971,
              quantity: 1,
              selling_plan: 805863499,
              properties: {
                _inveterate_subscription: true
              },
            },
            {
              id: 39742437163083,
              quantity: 1,
              properties: {
                _inveterate_free_signup_gift: true
              }
            }
          ]}),
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
        }).then(res => res.json()).then(items => {
          console.log(items);
          window.NSCart.open()
        });
      });
  });
}

/*Start Hide Recharge Widget Code for International Markets*/
/*
$(document).ready(function(){
  var interval = setInterval(function(){
    if ($('.onetime-radio').length) {
      fetch('/browsing_context_suggestions.json')
      .then(res=> {
        return res.json();
      })
      .then(result=> {
        // console.log(result);
        var country_code = result.detected_values.country.handle;
        console.log('country_code>>>', country_code);
        if(country_code == 'US') {
          $('.rc-widget').show();
        } else {
          $('.onetime-radio').click();
          $('.rc-widget').hide();
        }
      });
      clearInterval(interval);
    }
  },100);
});
*/
/*End Hide Recharge Widget Code for International Markets*/

/*Start Add framework for multiple and rotating annoucement bar ticket 000041*/
/*
var slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("announcement-bar__content");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
    
  slides[slideIndex-1]?.style.display = "flex";
}

//let slideIndex = 0;
showSlidesAuto();

function showSlidesAuto() {
  let i;
  let slides = document.getElementsByClassName("announcement-bar__content");
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  slideIndex++;
  if (slideIndex > slides.length) {slideIndex = 1}
  slides[slideIndex-1].style.display = "flex";
  setTimeout(showSlidesAuto, 3000); // Change image every 2 seconds
}
*/
/*End Add framework for rotating annoucement ticket 000041*/

/*
document.addEventListener('rebuy.show', function(event){
  console.log('rebuy.show event', event.detail);
  setTimeout(() => {
    const collectionElements = document.querySelectorAll(".rebuy-cart__flyout-item-product-title .rebuy-cart__flyout-item-variant-title")

    collectionElements.forEach((item) => {
        item.remove()
    })
    const products = Rebuy.Cart.cart.items
    const productElements = document.querySelectorAll(".rebuy-cart__flyout-item-product-title")

    products.forEach((item, index) => {
        var itemTags = item.product.tags.split(",")
        var itemCollectionTag = itemTags.filter(tag => tag.includes("collection_"));
        var itemCollectionTagString = itemCollectionTag.toString()
        var collection = itemCollectionTagString.replace(' collection_','');

        console.log(`${item.title} needs collection ${collection}`)

        var collectionElement = document.createElement("div")
        collectionElement.textContent = collection
        collectionElement.style.display = "none"
        collectionElement.classList.add('rebuy-cart__flyout-item-variant-title')
        productElements[index].appendChild(collectionElement)
    })
}, 100)
});
*/